import styled from 'styled-components/macro';

export const FilterWrapper = styled.div`
    width: 172px;
`;
